import { mediaUtil } from '../utils';
import { portfolioService } from '../../services/homii-services';
import _ from 'lodash';

async function fetchAllPortfolios() {
    const fetchedPortfolios = await portfolioService.getAllPortfolios();    
    let portfoliosWithImages = [];
    _.map(fetchedPortfolios, (portfolio) => {
        const portfolioWithImages = mediaUtil.generatePortfolioImageUrls(portfolio);
        portfoliosWithImages.push(portfolioWithImages);
    });    
    return portfoliosWithImages;
}

async function fetchSelectedRoomPortfolioById(portfolioId) {    
    const portfolio = await portfolioService
        .getPortfolioById(portfolioId)
        .then((response) => {
            const portfolioWithImages = mediaUtil.generatePortfolioImageUrls(response);
            return portfolioWithImages;
        });
    return portfolio;
};

export default {
    fetchAllPortfolios,
    fetchSelectedRoomPortfolioById
};